"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.optionalKeys = exports.getName = exports.getIcon = exports.filterNonBlock = exports.filterBlock = exports.CBlock = exports.BLOCK_STATUS_NAME = exports.BLOCK_STATUS_ICON = exports.BLOCK_STATUS = exports.BLOCK_FUNCTION_NAME = exports.BLOCK_FUNCTION_ICON = exports.BLOCK_FUNCTION = exports.BLOCKTYPE = void 0;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
let BLOCKTYPE = exports.BLOCKTYPE = /*#__PURE__*/function (BLOCKTYPE) {
  BLOCKTYPE["CONCEPT"] = "concept";
  BLOCKTYPE["PARAGRAPH"] = "paragraph";
  BLOCKTYPE["MODULE"] = "module";
  BLOCKTYPE["STORY"] = "story";
  BLOCKTYPE["SOURCE"] = "source";
  BLOCKTYPE["BOOK"] = "book";
  BLOCKTYPE["CHAPTER"] = "chapter";
  BLOCKTYPE["EXCERPT"] = "excerpt";
  BLOCKTYPE["CHUNK"] = "chunk";
  BLOCKTYPE["QUOTE"] = "quote";
  BLOCKTYPE["PUBLISHABLE"] = "publishable";
  return BLOCKTYPE;
}({});
/*TODO = "todo",
QUERY = "query",
COURSE = "course",

FIGURE = "figure",
*/
;
let BLOCK_STATUS = exports.BLOCK_STATUS = /*#__PURE__*/function (BLOCK_STATUS) {
  BLOCK_STATUS["IDEA"] = "idea";
  BLOCK_STATUS["WIP"] = "wip";
  BLOCK_STATUS["DRAFT"] = "draft";
  BLOCK_STATUS["PUBLISHED"] = "published";
  return BLOCK_STATUS;
}({});
let BLOCK_STATUS_ICON = exports.BLOCK_STATUS_ICON = /*#__PURE__*/function (BLOCK_STATUS_ICON) {
  BLOCK_STATUS_ICON["idea"] = "fas fa-lightbulb";
  BLOCK_STATUS_ICON["wip"] = "fas fa-cogs";
  BLOCK_STATUS_ICON["draft"] = "fas fa-pencil-alt";
  BLOCK_STATUS_ICON["published"] = "fas fa-check";
  return BLOCK_STATUS_ICON;
}({});
let BLOCK_STATUS_NAME = exports.BLOCK_STATUS_NAME = /*#__PURE__*/function (BLOCK_STATUS_NAME) {
  BLOCK_STATUS_NAME["idea"] = "Idea";
  BLOCK_STATUS_NAME["wip"] = "WIP";
  BLOCK_STATUS_NAME["draft"] = "Draft";
  BLOCK_STATUS_NAME["published"] = "Published";
  return BLOCK_STATUS_NAME;
}({});
let BLOCK_FUNCTION = exports.BLOCK_FUNCTION = /*#__PURE__*/function (BLOCK_FUNCTION) {
  BLOCK_FUNCTION["NONE"] = "none";
  BLOCK_FUNCTION["HOOK"] = "hook";
  BLOCK_FUNCTION["SUPPORT"] = "support";
  BLOCK_FUNCTION["OBJECTION"] = "objection";
  BLOCK_FUNCTION["REBUTTAL"] = "rebuttal";
  BLOCK_FUNCTION["CONCLUSION"] = "conclusion";
  return BLOCK_FUNCTION;
}({});
let BLOCK_FUNCTION_ICON = exports.BLOCK_FUNCTION_ICON = /*#__PURE__*/function (BLOCK_FUNCTION_ICON) {
  BLOCK_FUNCTION_ICON["hook"] = "fas fa-anchor";
  BLOCK_FUNCTION_ICON["support"] = "fas fa-thumbs-up";
  BLOCK_FUNCTION_ICON["objection"] = "fas fa-thumbs-down";
  BLOCK_FUNCTION_ICON["rebuttal"] = "fas fa-reply";
  BLOCK_FUNCTION_ICON["conclusion"] = "fas fa-flag-checkered";
  return BLOCK_FUNCTION_ICON;
}({});
let BLOCK_FUNCTION_NAME = exports.BLOCK_FUNCTION_NAME = /*#__PURE__*/function (BLOCK_FUNCTION_NAME) {
  BLOCK_FUNCTION_NAME["none"] = "None";
  BLOCK_FUNCTION_NAME["hook"] = "Hook";
  BLOCK_FUNCTION_NAME["support"] = "Support";
  BLOCK_FUNCTION_NAME["objection"] = "Objection";
  BLOCK_FUNCTION_NAME["rebuttal"] = "Rebuttal";
  BLOCK_FUNCTION_NAME["conclusion"] = "Conclusion";
  return BLOCK_FUNCTION_NAME;
}({});
const getName = block => {
  return block.name ? block.name : `[${block.blockId}]`;
};
exports.getName = getName;
const getIcon = block => {
  if (block.blockType == BLOCKTYPE.CONCEPT) {
    const c = require("./concept");
    const concept = c.filterConcept(block);
    if (concept.conceptType) {
      return c.CONCEPT_CATEGORY_ICON[concept.conceptType];
    }
    return "fas fa-lightbulb";
  } else if (block.blockType == BLOCKTYPE.PARAGRAPH) {
    return "fas fa-paragraph";
  } else if (block.blockType == BLOCKTYPE.MODULE) {
    return "fas fa-graduation-cap";
  } else if (block.blockType == BLOCKTYPE.STORY) {
    return "fas fa-blog";
  } else if (block.blockType == BLOCKTYPE.SOURCE) {
    return "fas fa-scroll";
  } else if (block.blockType == BLOCKTYPE.CHUNK) {
    return "fas fa-cube";
  } else if (block.blockType == BLOCKTYPE.EXCERPT) {
    return "fas fa-cheese";
  } else if (block.blockType == BLOCKTYPE.QUOTE) {
    return "fas fa-quote-right";
  } else if (block.blockType == BLOCKTYPE.BOOK) {
    return "fas fa-book";
  } else if (block.blockType == BLOCKTYPE.CHAPTER) {
    return "fas fa-puzzle-piece";
  }
  return "fas fa-question";

  /*
  switch (block.blockType) {
      case BLOCKTYPE.CONCEPT:
          return "fas fa-lightbulb";
      case BLOCKTYPE.PARAGRAPH:
          return "fas fa-paragraph";
      case BLOCKTYPE.TODO:
          return "fas fa-list";
      case BLOCKTYPE.QUERY:
          return "fas fa-search";
      case BLOCKTYPE.STORY:
          return "fas fa-book";
      case BLOCKTYPE.SOURCE:
          return "fas fa-link";
      case BLOCKTYPE.CHUNK:
          return "fas fa-cube";
      case BLOCKTYPE.EXCERPT:
          return "fas fa-quote-left";
      case BLOCKTYPE.COURSE:
          return "fas fa-graduation-cap";
      case BLOCKTYPE.BOOK:
          return "fas fa-book-open";
      case BLOCKTYPE.CHAPTER:
          return "fas fa-bookmark";
      case BLOCKTYPE.SECTION:
          return "fas fa-folder";
      case BLOCKTYPE.FIGURE:
          return "fas fa-image";
      case BLOCKTYPE.QUOTE:
          return "fas fa-quote-right";
      default:
         
  }*/
};

/**
 * the core data of the block
 */
exports.getIcon = getIcon;
class CBlock {
  constructor() {
    _defineProperty(this, "blockId", null);
    // unique identifier
    _defineProperty(this, "blockType", null);
    // the type of the block, used for rendering
    _defineProperty(this, "modifiedAt", null);
    // timestamp of the last modification
    _defineProperty(this, "name", null);
    // the name of the block, used as title, key is name because arborist uses it
    _defineProperty(this, "message", null);
    // the main message of the block / aka headline
    _defineProperty(this, "content", null);
    // the content of the block
    _defineProperty(this, "embeddings", null);
    // the embeddings of the block, used for similarity search
    _defineProperty(this, "status", null);
  } // the status of the block, used for filtering    
}
exports.CBlock = CBlock;
;

/*  
orderValue: string | null = null; // the order index of the block, used for sorting


/**  RELATIONSHIP DATA * /
parentId: string | null = null; // the parent block id
referencedId: string | null = null; // the referenced block id
imageId: string | null = null; // the image id, if publishable
addressedId: string | null = null; // the addressed concept of the paragraph
pertainedId: string | null = null; // the pertained dimension of the paragraph, this is a child-concept of the addressed concept
paragraphFunction: BLOCK_FUNCTION | null = null; // the function of the paragraph inside the parent block

// when returned from the server, the core data referenced block is included
// DOES NOT INCLUDE parent of referenced block or other relations
referencedCore: IBlock | null = null; // the referenced block
refchildren: Array<IBlock> | null = null; // the children blocks - only filled in referenced Block!
usedImage: IImage | null = null; // the used image

inboundReferences: Array<IBlock> | null = null; // the inbound references
*/

;
const optionalKeys = exports.optionalKeys = [
// enter the key of the interface that is not in the class
'forceUpdate', 'references', 'embeds', 'parentId', 'children'];

/**
 * The type of an array of the properties
 */

/**
 * An array of the properties
 */
const propsArray = Object.keys(new CBlock());

/**
 * Get the properties from a bigger object
 * when collect==true, then also collect the optional keys that are only defined in the interface but not in the class
 */
const filterBlock = (props, {
  fallback = {},
  override = {}
} = {}, collect = false) => {
  //console.log("filterBlock: ", props, override)

  const data = Object.assign(propsArray.concat(collect ? optionalKeys : []).reduce((r, k) => {
    // do not overwrite the IEntry values with undefined
    return _objectSpread(_objectSpread({}, r), {}, {
      [k]: function (_props$k, _props$k$localeCompar) {
        if (props[k] !== undefined && ((_props$k = props[k]) === null || _props$k === void 0 || (_props$k$localeCompar = _props$k.localeCompare) === null || _props$k$localeCompar === void 0 ? void 0 : _props$k$localeCompar.call(_props$k, '')) !== 0) {
          return props[k];
        }
        if (fallback[k] !== undefined) {
          return fallback[k];
        }
        if (r[k] !== null) {
          return r[k];
        }
        return undefined;
      }()
    });
  }, new CBlock()), override);
  return data;
};
exports.filterBlock = filterBlock;
const filterNonBlock = props => Object.keys(props).reduce((r, k) => {
  return Object.assign(r, !propsArray.includes(k) ? {
    [k]: props[k]
  } : {});
}, {});
exports.filterNonBlock = filterNonBlock;